import script from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=0292922d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0292922d"]])

export default __exports__